// PhotoRenderer + a select-circle overlay, for the book editor's multi-select gallery
// ({ multiSelect : true }). The circle is a RAW DOM span (not an fx component) so its
// visibility is driven purely by CSS: hidden by default, shown on :hover or when a
// selection is active (.has-selection). An fx component would get an inline opacity from
// show() that overrides the CSS. Selection state lives on models.Photo.selected so it
// survives virtualisation. (Sorts after PhotoRenderer.js so the parent loads first.)
fx.ns("shared.renderers", class PhotoSelectableRenderer extends shared.renderers.PhotoRenderer {

	constructor(data, sharedData)
	{
		super(data);

		this._shared = sharedData;

		// fx keeps only the leaf class name -> re-add PhotoRenderer for its styling
		this.className = "PhotoRenderer";

		this._onSelectClickHandler = this._onSelectClick.bind(this);
	}

	onReady()
	{
		super.onReady();

		if (!this.selectCircle)
		{
			this.selectCircle = document.createElement("span");
			this.selectCircle.className = "select-circle";
			this.node.appendChild(this.selectCircle);

			this.selectCircle.addEventListener("mousedown", this._onSelectMouseDown);
			this.selectCircle.addEventListener("click", this._onSelectClickHandler);
		}

		this._syncSelected();
	}

	_syncSelected()
	{
		let selected = !!this.data.selected;

		if (this.selectCircle)
			this.selectCircle.classList.toggle("selected", selected);

		this.toggleClass("photo-selected", selected);
	}

	// keep the mousedown from reaching the editor-level drag listener
	_onSelectMouseDown(e)
	{
		if (e && e.stopPropagation) e.stopPropagation();
	}

	_onSelectClick(e)
	{
		if (e)
		{
			if (e.stopPropagation) e.stopPropagation();
			if (e.preventDefault) e.preventDefault();
		}

		// route through the grid so the selection cap is enforced ; the model update
		// then refreshes this renderer's circle via onDataUpdated. Fallback if no owner.
		if (this._shared && this._shared.owner && this._shared.owner.toggleSelection)
			this._shared.owner.toggleSelection(this.data);
		else
		{
			this.data.selected = !this.data.selected;
			this._syncSelected();
		}
	}

	onDataUpdated(action)
	{
		super.onDataUpdated(action);

		if (action && action.impacts && action.impacts("selected"))
			this._syncSelected();
	}
});
